import { render, staticRenderFns } from "./key-figures.card.vue?vue&type=template&id=92079856&"
import script from "./key-figures.card.vue?vue&type=script&lang=js&"
export * from "./key-figures.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports